<template>
  <div class="pp-dialog-root">
  <transition name="pp-dialog-fade">
    <div
      v-if="active"
      class="pp-dialog"
      :class="{ 'pp-dialog--sheet': isSheet }"
      @mousedown.self="close"
    >
      <div
        class="pp-dialog__panel"
        :style="isSheet ? null : { maxWidth: `${maxWidth}px` }"
        role="dialog"
        aria-modal="true"
      >
        <div v-if="isSheet" class="pp-dialog__handle" @click="close" />
        <button
          v-if="closable && !isSheet"
          type="button"
          class="pp-dialog__close"
          aria-label="Fechar"
          @click="close"
        >
          <x-icon size="20" />
        </button>
        <slot />
      </div>
    </div>
  </transition>
  </div>
</template>

<script>
import { XIcon } from "vue-feather-icons";
import { isMobileWidth } from "./constants";

// Dialogos abertos ao mesmo tempo (paywall por cima do compartilhar etc.): o
// scroll do body so volta quando o ultimo fechar.
let openCount = 0;

// Modal da camada nxp- que vira folha (bottom sheet) abaixo de 768px.
// O vs-popup do Vuesax e legado e nao tem a variacao de folha.
export default {
  name: "PpDialog",
  components: { XIcon },
  props: {
    active: { type: Boolean, default: false },
    maxWidth: { type: Number, default: 520 },
    closable: { type: Boolean, default: true },
    // null = decide pela largura da tela
    sheet: { type: Boolean, default: null },
  },
  data: () => ({ mobile: isMobileWidth() }),
  computed: {
    isSheet() {
      return this.sheet === null ? this.mobile : this.sheet;
    },
  },
  watch: {
    active(value) {
      this.lockScroll(value);
    },
  },
  mounted() {
    // Vai para o body para escapar de overflow/transform dos pais.
    document.body.appendChild(this.$el);
    window.addEventListener("resize", this.onResize);
    window.addEventListener("keydown", this.onKeydown);
    if (this.active) this.lockScroll(true);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    window.removeEventListener("keydown", this.onKeydown);
    this.lockScroll(false);
    if (this.$el && this.$el.parentNode === document.body) {
      document.body.removeChild(this.$el);
    }
  },
  methods: {
    close() {
      if (!this.closable) return;
      this.$emit("update:active", false);
      this.$emit("close");
    },
    onResize() {
      this.mobile = isMobileWidth();
    },
    onKeydown(event) {
      if (this.active && event.key === "Escape") this.close();
    },
    lockScroll(lock) {
      // Cada instancia conta uma vez, mesmo que o watcher e o destroy chamem de novo.
      if (!!this.locked === lock) return;
      this.locked = lock;
      openCount = Math.max(0, openCount + (lock ? 1 : -1));
      try {
        if (lock) document.body.style.overflow = "hidden";
        else if (openCount === 0) document.body.style.overflow = "";
      } catch (e) {
        // no-op
      }
    },
  },
};
</script>

<style lang="scss">
.pp-dialog {
  position: fixed;
  inset: 0;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 52000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(6, 21, 43, 0.45);
  font-family: Roboto, sans-serif;

  &__panel {
    position: relative;
    width: 100%;
    max-height: calc(100vh - 32px);
    overflow-y: auto;
    padding: 24px;
    border-radius: 16px;
    background: #fff;
    box-shadow: 0 16px 48px rgba(9, 30, 66, 0.25);
  }

  &__close {
    position: absolute;
    top: 20px;
    right: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 8px;
    background: transparent;
    color: #4f4f4f;
    cursor: pointer;

    &:hover {
      background: #e7edf0;
    }
  }

  &__handle {
    width: 40px;
    height: 4px;
    margin: -8px auto 16px;
    border-radius: 9999px;
    background: #d4d4d4;
    cursor: pointer;
  }

  &--sheet {
    align-items: flex-end;
    padding: 0;

    .pp-dialog__panel {
      max-width: none;
      max-height: 88vh;
      padding: 16px 16px 24px;
      border-radius: 16px 16px 0 0;
    }
  }
}

.pp-dialog-fade-enter-active,
.pp-dialog-fade-leave-active {
  transition: opacity 0.2s ease;

  .pp-dialog__panel {
    transition: transform 0.2s ease;
  }
}

.pp-dialog-fade-enter,
.pp-dialog-fade-leave-to {
  opacity: 0;

  &.pp-dialog--sheet .pp-dialog__panel {
    transform: translateY(40px);
  }
}
</style>
